<template>
    <div>
        <v-toolbar flat fixed>
            <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
            <v-toolbar-title>Select User Type</v-toolbar-title>
        </v-toolbar>

        <div class="hasToolbar">

            <!-- <v-alert color="info" dense :value="true" style="background-color:#edf0f7 !important;font-size:12px">You can change user type later also.</v-alert> -->
            <v-card class="ma-4">
                <v-list two-line nopadding>
                  <v-list-tile @click="fn_changeUserType(1)">
                    <v-list-tile-content>
                      <v-list-tile-title>I'm a Business Owner</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                      <v-icon color="primary">{{userType == 1 ? 'radio_button_checked' : 'radio_button_unchecked'}}</v-icon>
                      <!-- <img src="../../assets/icon_done.svg" style="width:24px"/> -->
                    </v-list-tile-action>
                  </v-list-tile>

                  <v-divider></v-divider>

                  <v-list-tile @click="fn_changeUserType(2)">
                    <v-list-tile-content>
                      <v-list-tile-title>I'm an Accountant</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                      <v-icon color="primary">{{userType == 2 ? 'radio_button_checked' : 'radio_button_unchecked'}}</v-icon>
                      <!-- <img src="../../assets/icon_done.svg" style="width:24px"/> -->
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list>
            </v-card>
            
        </div>

        <div white-background full-width nopadding style="position:fixed;bottom:0;">
            <v-layout row wrap>
                <v-flex xs12 sm12 md12 height48>
                    <v-btn color="primary" full-height nomargin block no-round-borders noshadow @click="fn_updateBusiness">Save</v-btn>
                </v-flex>
            </v-layout>
        </div>

        <dialog-confirmation ref="ref_dialogConfirmation" :header="header" :confirmationMessage="confirmationMessage" :actionMethod="actionMethod"></dialog-confirmation>
    </div>
</template>

<script>

import dialogConfirmation from '../dialogs/dialog_confirmation'

    export default{
        data(){
            return{
                userType:null,
                header:null,
                confirmationMessage:null,
                actionMethod:null,
                // confirmExit:false
            }
        },

        components:{
            'dialog-confirmation':dialogConfirmation
        },

        methods:{

            fn_goBack: function(){
                this.$router.go(-1);
            },

            fn_openDialogConfirmation: function(){
                this.header = this.userType == 1 ? 'Business Owner' : 'Accountant';
                this.confirmationMessage = this.userType == 1 ? 'Register as a Business Owner' : 'Register as an Accountant';
                this.actionMethod = this.fn_getToken;
                this.$refs['ref_dialogConfirmation'].openDialogWeb();
            },

            // fn_openDialogConfirmation: function(type){
            //     if(type=='exit'){
            //         this.header = "Quit Registration";
            //         this.confirmationMessage = null;
            //         this.actionMethod = this.fn_confirmExit;
            //     }
            //     else{
            //         this.header = this.userType == 1 ? 'Business Owner' : 'Accountant';
            //         this.confirmationMessage = this.userType == 1 ? 'Register as a Business Owner' : 'Register as an Accountant';
            //         this.actionMethod = this.fn_getToken;
            //     }

            //     if(this.userType == this.$root.CurrentBusiness.userType){
            //         this.$refs['ref_dialogConfirmation'].openDialogWeb();    
            //     }
            //     else{
            //         this.fn_goBack();
            //     }
                
            // },

            // fn_confirmExit: function(){
            //     this.confirmExit = true;
            //     this.fn_closeDialog();
            //     this.fn_goBack();
            // },

            fn_closeDialog: function(){
                this.$refs['ref_dialogConfirmation'].closeDialogWeb();
            },

            fn_changeUserType: function(val){
                this.userType = val;
                this.confirmationMessage = val == 1 ? 'Register as a Business Owner' : 'Register as an Accountant';
            },

            fn_updateBusiness: function(){
                // this.confirmExit = true;
                if(this.$root.CurrentBusiness.UserType == this.userType){
                    this.fn_goBack();
                }
                else{
                    if(this.$root.CurrentBusiness.IsAccountantOnly){
                        this.$router.replace({path:'/registration/business/'+this.$root.CurrentBusiness.BusinessID+'/edit', query:{usertype:this.userType}});
                    }
                    else{
                        // this.fn_getToken();
                        this.fn_openDialogConfirmation();
                    }
                }
            },

            fn_getToken: function(){
                this.fn_closeDialog();
                this.showLoading('Please wait...');
                this.$root.fn_getAuthToken(token=>{
                    if(token == 'error'){
                        this.hideLoading();
                    }
                    else{
                        this.fn_setUserType(token);
                    }
                })
            },

            fn_setUserType: function(token){
                if(!navigator.onLine){
                    this.showToast('Internet not available');
                    this.hideLoading();
                    return;
                }
                
                let self = this;
                let dataObj = {};
                dataObj.token = token;
                dataObj.usertype = this.userType;
                dataObj.businessId = this.$root.CurrentBusiness.BusinessID;
                this.getServerData('SetUserType', dataObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.$root.CurrentBusiness.UserType = self.userType;
                            self.hideLoading();
                            let ownerType = self.userType == 1 ? "business owner" : "accountant";
                            self.showToast("User updated to " + ownerType);
                            self.fn_goBack();
                            // self.fn_updateBusiness();
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.hideLoading();
                            if(typeof JSON.parse(error) == 'object'){
                                let response = JSON.parse(error);
                                self.showToast(response.Message);
                            }
                        }, 
                    }
                );
            },

            // fn_setUserName: function(token){
            //     if(!navigator.onLine){
            //         this.showToast('Internet not available');
            //         return;
            //     }
                
            //     let self = this;
            //     let dataObj = {};
            //     dataObj.token = token;
            //     dataObj.Name = this.userName;
            //     this.getServerData('SetUserName', dataObj, 
            //         {
            //             onSuccess: function(response){
            //                 console.log(response);
            //                 self.hideLoading();
            //             }, 
            //             onError: function(error){
            //                 console.log(error);
            //                 self.hideLoading();
            //                 if(typeof JSON.parse(error) == 'object'){
            //                     let response = JSON.parse(error);
            //                     self.showToast(response.Message);
            //                 }
            //             }, 
            //         }
            //     );
            // },
        },

        mounted: function(){
            // this.userName = this.$route.query.userName;
            window.js_globals.fn_onBackPress = this.fn_goBack;
            this.userType = this.$root.CurrentBusiness.UserType;
        },

        beforeRouteLeave (to, from, next) {
            if(this.$refs['ref_dialogConfirmation'].dialog_confimation){
                this.fn_closeDialog();
                next(false);
            }
            // else if(!this.confirmExit){
            //     this.fn_openDialogConfirmation('exit');
            //     next(false);
            // }
            else{
                next();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/registration/user_type.vue